// Iter-158.13.2.20e.16 — Setup checklist helper (Production Overview).
//
// Pure function powering the "Finish setting up your Production"
// card on `BetaProject.jsx`. Given the three pieces of state that
// already exist on the Hub, it decides:
//   * whether Canonical Script is complete,
//   * whether Backup is complete / paused / missing,
//   * whether the whole card should render (Owner/Admin only, and
//     only while at least one of the two setup items is still
//     incomplete).
//
// Inputs come exclusively from state that already flows to the Hub:
//   * `hasScript`     — truthy when `state.script` (from the Hub
//                        GET payload) is present.
//   * `backupStatus`  — one of "active" | "paused" | "none" | null.
//                        Matches the derivation already used by
//                        `ProjectHeader.loadBackupStatus`.
//   * `callerRole`    — "owner" | "admin" | "contributor" |
//                        "viewer" | "producer" |
//                        "script_supervisor" | null. Sourced from
//                        the Hub GET (`project.role`).
//
// Contract (locked by `setupChecklist.test.js`):
//   * scriptComplete = Boolean(hasScript)
//   * backupComplete = backupStatus === "active"
//   * backupPaused   = backupStatus === "paused"
//   * canAct         = callerRole === "owner" || callerRole === "admin"
//   * showCard       = canAct && !(scriptComplete && backupComplete)
//
// A paused backup keeps the card visible so the producer sees a
// calm needs-attention state and can click straight through to the
// Backup surface.

export function computeSetupChecklist({ hasScript, backupStatus, callerRole } = {}) {
    const role = (callerRole || "").toLowerCase();
    const canAct = role === "owner" || role === "admin";
    const scriptComplete = Boolean(hasScript);
    const backupComplete = backupStatus === "active";
    const backupPaused = backupStatus === "paused";
    const backupMissing = !backupComplete && !backupPaused;
    const showCard = canAct && !(scriptComplete && backupComplete);
    return {
        canAct,
        scriptComplete,
        backupComplete,
        backupPaused,
        backupMissing,
        showCard,
    };
}
